<template>
  <section
    class="clients section reveal-fade mt-32 mb-32"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
    ]"
  >
    <div class="container">
      <div
        class="clients-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider',
        ]"
      >
        <c-section-header :data="clientHeader" class="center-content mt-32" />
        <ul class="logo-list list-reset">
          <li class="reveal-from-bottom has-shadow client-logo next-logo">
            <c-image
              :src="require('@/assets/images/customer-logo-1.jpg')"
              alt="Client 01"
              :width="90"
              :height="20"
            />
          </li>
          <li
            class="reveal-from-bottom has-shadow client-logo vetstage-logo"
            data-reveal-delay="150"
          >
            <c-image
              :src="require('@/assets/images/customer-logo-2.jpg')"
              alt="Client 02"
              :width="90"
              :height="30"
            />
          </li>
          <li
            class="reveal-from-bottom has-shadow client-logo enpal-logo"
            data-reveal-delay="300"
          >
            <c-image
              :src="require('@/assets/images/customer-logo-3.svg')"
              alt="Client 03"
              :width="90"
              :height="40"
            />
          </li>
          <li
            class="reveal-from-bottom has-shadow client-logo"
            data-reveal-delay="450"
          >
            <c-image
              :src="require('@/assets/images/customer-logo-4.jpg')"
              alt="Client 04"
              :width="90"
              :height="31"
            />
          </li>
          <li
            class="reveal-from-bottom has-shadow client-logo inreal-logo"
            data-reveal-delay="450"
          >
            <c-image
              :src="require('@/assets/images/customer-logo-5.jpg')"
              alt="Client 04"
              :width="90"
              :height="31"
            />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from "@/utils/SectionProps.js";
import CImage from "@/components/elements/Image.vue";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";

export default {
  name: "CClients",
  components: {
    CImage,
    CSectionHeader,
  },
  mixins: [SectionProps],
  props: {
    headingTitle: String,
    headingText: String,
  },
  computed: {
    clientHeader() {
      return {
        title: this.headingTitle,
        paragraph: this.headingText,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
// shared styles
.client-logo {
  margin: 8px;
  min-height: 164px;
  min-width: 164px;
  max-height: 164px;
  max-width: 164px;
  * {
    top: 50%;
  }
}
.clients-inner li {
  padding: 40px;
  padding-top: 64px;
}
// mobile
@media (max-width: 600px) {
  .logo-list {
    flex-wrap: wrap;
    -webkit-box-orient: horizontal;
    flex-direction: row;
  }
  // shared styles
  .client-logo {
    margin: 8px;
    min-height: 128px;
    min-width: 128px;
    max-height: 128px;
    max-width: 128px;
  }
  .clients-inner li {
    padding: 24px;
    padding-top: 40px;
  }
  .next-logo {
    padding-top: 24px !important;
  }
  .vetstage-logo {
    padding-top: 54px !important;
  }
  .enpal-logo {
    padding-top: 56px !important;
  }
  .inreal-logo {
    padding-top: 60px !important;
  }
}
// tablet desktop
@media (min-width: 600px) {
  .client-logo {
    * {
      margin: 0;
      position: absolute;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
    img {
      display: inline-block !important;
    }
  }
}
</style>
